<div class="container">

  <app-header-dialog [iconName]="'store_mall_directory'">
    Documento
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <div class='tab-content'>

      <mat-form-field class="full-width" appearance="outline">
        <textarea class='text-area' matInput [errorStateMatcher]="matcher" placeholder="Documento"
          [formControl]="entityForm.controls.doc" autocomplete="off">
                        </textarea>
      </mat-form-field>

    </div>
  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button *ngIf="!isEdit" matTooltip='Insert' mat-raised-button (click)="matDialogRef.close(['insert',entityForm])"
      [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button *ngIf="isEdit" matTooltip='Update' mat-raised-button (click)="matDialogRef.close(['update',entityForm])"
      [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>